<template>
  <v-container fill-height style="max-width:100%;">
    <v-row style="height:100%;">
      <v-col style="height:100%;padding:0;">
        <v-card flat class="card-style">
          <div class="card-style-title">
            Reported cycling casualties
            <div class="btnCont">
              <iframe-modal :id="id" :src="src" :width="850" :height="900" />
              <v-btn
                depressed
                rounded
                color="#00486b"
                style="color:#fff"
                width="7em"
                :href="mapDatasetUrls"
                target="_blank"
              >
                Data
              </v-btn>
            </div>
          </div>
          <v-container class="contentHolder">
            <v-container v-if="overlay">
              <v-overlay :absolute="true" :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
              </v-overlay>
            </v-container>
            <v-container v-if="!overlay" class="contentHolder">
              <v-row>
                <v-col cols="12">
                  <div class="description">
                    <p>
                      Numbers of cyclists slightly injured, seriously injured and killed on roads
                    </p>
                    <p class="source">
                      <span>
                        Data Source:
                        <a
                          target="_blank"
                          href="https://www.transport.gov.scot/our-approach/statistics/#42761">
                          Key Reported Road Casualty Statistics – Transport Scotland
                        </a>
                      </span>
                    </p>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="12">
                  <StackedBarChart
                    :colors="colors"
                    :data="results"
                    :height="height"
                    :width="width"
                    :xAxis="{label: 'Year'}"
                  />
                </v-col>
              </v-row>
              <v-row>
              <v-col cols="12" sm="12">
                <p class="footer-info">
                  Due to changes in the way casualty severities are recorded,
                  serious and slight figures in 2019 and 2020
                  are not comparable with previous years.
                </p>
              </v-col>
            </v-row>
            </v-container>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
// eslint-disable-next-line import/no-unresolved
import StackedBarChart from '@/components/stackedBarChart.vue';
// eslint-disable-next-line import/no-unresolved
import iframeModal from '@/components/iframeModal.vue';

export default {
  components: {
    StackedBarChart,
    iframeModal,
  },
  data() {
    return {
      results: [],
      overlay: true,
      colors: ['#00b0db', '#143c6a', '#ed6d91'],
      height: '30em',
      width: '100%',
      id: 'safetyStatistics',
      src: 'safetyStatistics',
    };
  },
  computed: {
    ...mapGetters(['compositeDataset']),
    mapDatasetUrls() {
      let d = null;
      if (this.compositeDataset && this.compositeDataset.safetyStatisticsDataset) {
        d = this.compositeDataset.safetyStatisticsDataset.dataset;
        this.content(this.compositeDataset.safetyStatisticsDataset.apiResource);
      } else {
        console.error('No API Resource: (safety statistics)');
      }
      return d;
    },
  },
  methods: {
    async content(resource) {
      const query = 'sort(+Year)';
      const params = { datasetGUID: resource, query };
      const newResults = await this.$store.dispatch('fetchData', params);
      this.results = newResults.data;
      this.overlay = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.card-style {
  padding: 2em;
  width: 100%;
  height: 100%;
  justify-content: center;
}
.description {
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: center;
  p {
    font-size: 1em;
    font-weight: bold;
  }
  .source {
    font-size: 0.8em;
    font-style: italic;
    font-weight: bold;
  }
}
.footer-info {
    font-size: 0.8em;
    font-style: italic;
    font-weight: bold;
  }
@media (min-width: 650px) {
  .description {
    display: flex;
    height: 100%;
    flex-direction: column;
    justify-content: center;
    p {
      font-size: 1.2em;
      font-weight: bold;
    }
  }
  .contentHolder {
    margin: 10px;
    max-width: 100%;
  }
}
</style>
